import { ReactNode, useEffect, useState } from "react";
import { SelectionDropdown } from "@/frontend/shared/ui/SelectionDropdown";
import { DropdownInput } from "@/frontend/shared/ui/DropdownInput";

type TSelectionOptions = {
  value: string;
  label: string;
};

interface DropdownProps {
  search?: boolean;
  options: TSelectionOptions[];
  onChange?: (value: string) => void;
  onClose?: () => void;
  onFocus?: () => void;
  inputSize?: "xs" | "small" | "large";
  value?: string;
  className?: string;
  dropdownPosition?: "top" | "bottom";
  maxHeight?: number;
  isMaxWidth?: boolean;
  children?: ReactNode;
  getValueLabel?: (value: TSelectionOptions | undefined) => string;
  containerClassName?: string;
}

export function Dropdown({ options = [], search, value, onChange, ...rest }: DropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const selectedOption = options.find((o) => o.value === value);
  const [query, setQuery] = useState(selectedOption?.label || "");

  useEffect(() => {
    setQuery(selectedOption?.label || "");
  }, [options]);

  if (search) {
    return (
      <DropdownInput
        isOpen={isOpen}
        selected={value}
        options={options}
        onClose={() => setIsOpen(false)}
        onSelect={(s) => {
          const selected = options.find((o) => o.label === s);
          onChange?.(selected?.value || "");
          setQuery(s);
        }}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onBlur={() => {
          const selected = options.find((o) => o.label === query);
          if (selected) onChange?.(selected.value);
          setQuery(selected?.label || "");
        }}
        {...rest}
      />
    );
  }
  return (
    <SelectionDropdown
      isOpen={isOpen}
      options={options}
      onFocus={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      onChange={onChange}
      value={value}
      {...rest}
    />
  );
}
